import { mergeRefs, PropGetter } from '@chakra-ui/react-utils';
import { dataAttr } from '@chakra-ui/utils';
import { useCallback, useMemo } from 'react';
import { useRangeSliderContext } from './range-slider-context';
import { orient } from './range-slider-utils';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useRangeSliderTrack = () => {
  const { orientation, isDisabled, trackRef } = useRangeSliderContext();

  const trackStyle: React.CSSProperties = useMemo(
    () => ({
      position: 'relative',
      ...orient({
        orientation,
        vertical: {
          height: '100%',
        },
        horizontal: {
          width: '100%',
        },
      }),
    }),
    [orientation]
  );

  const getTrackProps: PropGetter = useCallback(
    // eslint-disable-next-line no-null/no-null
    (propss = {}, ref = null) => ({
      ...propss,
      ref: mergeRefs(ref, trackRef),
      'data-disabled': dataAttr(isDisabled),
      style: {
        ...propss.style,
        ...trackStyle,
      },
    }),
    [isDisabled, trackRef, trackStyle]
  );

  return {
    getTrackProps,
  };
};
